import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/book-consultation">Book Consultation</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact Info</h3>
          <p>Suite 240, 119 Kent Street</p>
          <p>Charlottetown, PE C1A 1N3</p>
          <p>Phone: 902-566-3622</p>
          <p>Email: <a href="mailto:lisa@canadianumbrella.ca">lisa@canadianumbrella.ca</a></p>
        </div>

        <div className="footer-section">
          <h3>Our Services</h3>
          <ul>
            <li>Permanent Resident Applications</li>
            <li>Temporary Resident Applications</li>
            <li>Other Services</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Follow Us</h4>
          <div className="social-links">
            <a href="https://www.linkedin.com/in/lisa-halliwell/" className="social-link">LinkedIn</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p>&copy; 2024 Canadian Umbrella Immigration Services Inc. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 